// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "build_v0.0.12/" + chunkId + ".js";
};